import { TREATMENT_DEFINITION_CANONICAL_BASE } from "@repo/data-store";

const BASE_PREFIX = `${TREATMENT_DEFINITION_CANONICAL_BASE}/`;
const ENCODED_PREFIX = "td_";

/**
 * A treatment's identity is its canonical URL. Everything this app mints sits
 * directly under one base, so the URL's own last segment addresses it and the
 * base rebuilds it. Canonicals from anywhere else keep the self-describing
 * encoded form — a bare segment has only one base to rebuild against, and
 * guessing would resolve to a different treatment.
 */
export function treatmentDefinitionRouteId(url: string): string {
  const segment = url.startsWith(BASE_PREFIX) ? url.slice(BASE_PREFIX.length) : undefined;
  // Only a clean path segment: a slash would span the base, and `?`/`#` would
  // stop being part of the path once the router puts it back in a URL.
  if (segment && !/[/?#]/.test(segment)) return segment;
  return `${ENCODED_PREFIX}${btoa(url).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "")}`;
}

export function treatmentDefinitionUrlFromRouteId(routeId: string | undefined): string | undefined {
  if (!routeId) return undefined;
  if (!routeId.startsWith(ENCODED_PREFIX)) return `${BASE_PREFIX}${routeId}`;
  try {
    const base64 = routeId.slice(ENCODED_PREFIX.length).replaceAll("-", "+").replaceAll("_", "/");
    const url = atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "="));
    return URL.canParse(url) ? url : undefined;
  } catch {
    return undefined;
  }
}
